import * as React from "react";

function IconWarning({color="#fff"}) {
  return (
    <svg
      width={20}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0a10 10 0 100 20 10 10 0 000-20zm0 18.333a8.333 8.333 0 110-16.666 8.333 8.333 0 010 16.666z"
        fill={color}
      />
      <path
        d="M10 11.725a1.083 1.083 0 01-1.083-1.083v-5a1.083 1.083 0 012.166 0v5A1.083 1.083 0 0110 11.725zM9.958 15.433a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z"
        fill={color}
      />
    </svg>
  );
}

export default IconWarning;
